import { Phone } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL } from "./data";
import { Chapter, Rise } from "./motion";

const WalkIn = () => (
  <section
    id="walkin"
    data-testid="walkin-section"
    className="border-b-2 border-ink bg-rust text-paper"
  >
    <div className="mx-auto max-w-[1500px] px-4 py-20 sm:px-6 lg:py-28">
      <Rise>
        <Chapter num="01" label="The house rules" dark />
      </Rise>

      <Rise delay={0.1}>
        <h2 className="mt-6 font-display text-[13vw] uppercase leading-[0.85] sm:text-8xl lg:text-[9rem]">
          Walk ins
          <br />
          preferred
        </h2>
      </Rise>

      <div className="mt-10 grid grid-cols-1 gap-10 lg:grid-cols-2">
        <Rise delay={0.15}>
          <p className="max-w-md text-lg font-medium sm:text-xl">
            No complicated online booking. No apps. No accounts.
            <span className="font-hand text-2xl"> Just come through and see us.</span>
          </p>
          <p className="mt-5 inline-flex items-center gap-2 font-hand text-xl text-paper">
            <svg
              viewBox="0 0 30 20"
              className="h-5 w-7 -rotate-3"
              role="img"
              aria-label="Intersex-inclusive progress pride flag"
            >
              <rect width="30" height="20" fill="#732982" />
              <rect width="30" height="16.67" fill="#24408e" />
              <rect width="30" height="13.33" fill="#008026" />
              <rect width="30" height="10" fill="#ffed00" />
              <rect width="30" height="6.67" fill="#ff8c00" />
              <rect width="30" height="3.33" fill="#e40303" />
              <polygon points="0,0 0,20 9,10" fill="#000000" />
              <polygon points="0,1.5 0,18.5 8.2,10" fill="#603813" />
              <polygon points="0,3 0,17 7.4,10" fill="#74d7ee" />
              <polygon points="0,4.5 0,15.5 6.6,10" fill="#ffafc8" />
              <polygon points="0,6 0,14 5.8,10" fill="#ffffff" />
              <polygon points="0,7.5 0,12.5 5,10" fill="#ffd800" />
              <circle cx="2.2" cy="10" r="1.4" fill="none" stroke="#7902aa" strokeWidth="0.8" />
            </svg>
            LGBT friendly — all welcome here.
          </p>
        </Rise>

        <Rise delay={0.25}>
          <div className="relative border-2 border-paper/60 p-6 sm:p-8">
            <div className="barber-pole barber-pole-md absolute -right-4 -top-8 rotate-3 sm:-right-6" aria-hidden="true">
              <span className="barber-pole-cap" />
              <span className="barber-pole-glass" />
              <span className="barber-pole-cap" />
            </div>
            <p className="font-mono2 text-[11px] font-bold uppercase tracking-[0.3em] text-paper/70">
              Prefer to call ahead?
            </p>
            <a
              href={PHONE_TEL}
              data-testid="walkin-phone-link"
              className="mt-3 inline-flex items-center gap-3 font-display text-5xl uppercase leading-none transition-colors hover:text-ink sm:text-6xl"
            >
              <Phone className="h-8 w-8 sm:h-10 sm:w-10" strokeWidth={2.5} />
              {PHONE_DISPLAY}
            </a>
            <p className="mt-4 font-mono2 text-[11px] uppercase tracking-[0.25em] text-paper/70">
              Appointments can also be made by phone
            </p>
          </div>
        </Rise>
      </div>
    </div>
  </section>
);

export default WalkIn;
